export default __webpack_public_path__ + "static/media/buzzer-stop-timer.2e08b3a5.mp3";